export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
    visible: !that.disabled
  },
  {
    title: that.$l('order_package_materialNo') || '包装编号',
    field: 'materialNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('order_package_materialName') || '包装名称',
    field: 'materialName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
    slots: {
      default: 'showName'
    }
  },
  {
    title: that.$l('order_package_materialSize') || '包装尺寸',
    field: 'materialSpec',
    minWidth: 180,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('order_package_boxVolume') || '包装体积(立方cm)',
    field: 'boxVolume',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('order_package_boxWeight') || '包装箱重量(g)',
    field: 'boxWeight',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('order_package_isSpecify') || '指定供应商',
    field: 'isSpecify',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('order_package_scmName') || '供应商名称',
    field: 'scmName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_label_isCustomerProvide') || '是否客供',
    field: 'isCustomerProvide',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isCustomerProvide'
    }
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_time') || '修改时间',
    field: 'modifyTime',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  }
]
